import * as yup from "yup";

const AnnouncementValidationSchema = yup.object().shape({
  id: yup.number().optional(),
  title: yup
    .string()
    .max(50, "Title must be 50 characters or less")
    .required("Title is required."),
  content: yup.string().required("Announcement is required."),
  tags: yup.array().of(yup.string()).required("Tags is required"),
  status: yup.string().required("Status is required."),
  announcementType: yup
    .object()
    .nullable()
    .required("Announcement type is required."),
  scheduledStartDate: yup
    .date()
    .required("Schedule send date/time is required."),
  scheduledEndDate: yup
    .date()
    .required("Schedule end date/time is required.")
    .test(
      "is-after-start",
      "End date must be after start date.",
      function validateEndDate(value) {
        const { scheduledStartDate } = this.parent;
        if (!value || !scheduledStartDate) return true;
        return value > scheduledStartDate;
      }
    ),
});

export default AnnouncementValidationSchema;
